import { clsx } from 'clsx'

import { analyticsNumberFormatter } from '../utils/index.js'

interface Props {
  data: { label: string; value: number }[]
  colors: string[]
  setActiveIndex: (index: number) => void
  className?: string
  labels: string[]
}

export const PieChartLegend = ({
  data,
  colors,
  setActiveIndex,
  className,
  labels,
}: Props) => {
  return (
    <div className={clsx('flex flex-col space-y-4', className)}>
      {data.map(({ label, value }, index) => (
        <div
          key={label}
          className="flex flex-row justify-between cursor-pointer"
          onMouseOver={() => setActiveIndex(index)}
          onFocus={() => setActiveIndex(index)}
          onMouseOut={() => setActiveIndex(-1)}
          onBlur={() => setActiveIndex(-1)}
        >
          <div className="flex items-center space-s-1 truncate">
            <div
              style={{ backgroundColor: colors[index] }}
              className="shrink-0 w-3 h-3 rounded-full"
            ></div>
            <div
              className="text-xs text-content-subdued truncate"
              title={labels[index]}
            >
              {labels[index]}
            </div>
          </div>
          <div className="text-xs text-content-subdued">
            {analyticsNumberFormatter(value)}
          </div>
        </div>
      ))}
    </div>
  )
}
